import { CustomTableCell, CustomTableHead, FormSectionHeader, Loader, NoData } from "@/components";
import { Button, Card, CardContent, Table, TableBody, TableHeader, TableRow } from "@/components/ui";
import useManualEntry from "./useManualEntry";
import { ArrowLeft, ArrowRight, RotateCcw, Trash2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { isFieldSkipped } from "./consts";
import { FormProvider } from "react-hook-form";

const ManualEntry = () => {
  const {
    form,
    renderDynamicField,
    headerFields,
    lineItemRows,
    lineItemFields,
    removeRow,
    addRow,
    onSubmit,
    balanceAmount,
    isRefetchingConfigFields,
    fieldDisabled,
    isListLoading,
    nextStageId,
    prevStageId,
    onPrev,
    onNext,
    isLoadingAuditData,
    hideLineItems,
    isNextJeMasterIdExists,
    hasEditPermission
  } = useManualEntry();

  return <div className="flex flex-col gap-5 w-full max-w-full overflow-hidden">
    {/* <div>
      Balance Amount: {balanceAmount || 0}
    </div> */}
    {isListLoading || isLoadingAuditData ? <Loader /> : 
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-5">
            <Card className="rounded-md">
              <CardContent>
                <FormSectionHeader>Document Header</FormSectionHeader>
                {isRefetchingConfigFields ? <Loader /> : 
                  headerFields?.length ?
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                      {headerFields?.map((field: any) => {
                        if (isFieldSkipped(field.fieldName)) return <></>
                        return renderDynamicField(field, form)
                      })}
                    </div> :
                    <NoData />
                }
              </CardContent>
            </Card>
            {hideLineItems ? <></> : <Card className="p-0 overflow-hidden">
              <CardContent className="px-0 !py-4 overflow-hidden">
                <div className="flex flex-row items-center justify-between pb-4">
                  <FormSectionHeader className="px-6" wrapperClassName="mb-0">Line Items</FormSectionHeader>
                  {isRefetchingConfigFields ? <></> : !fieldDisabled ? <Button variant="link" onClick={addRow} type="button">+ Add Line Item</Button> : <></>}
                </div>
                {isRefetchingConfigFields ? <Loader /> : 
                  lineItemRows?.length ? 
                    <div className="overflow-x-auto w-full block clear-both">
                      <Table className="min-w-max w-full table-auto">
                        <TableHeader>
                          <TableRow className="mb-3 rounded">
                            {lineItemFields.map((field: any) => {
                              if (isFieldSkipped(field.fieldName)) return <></>
                              return (
                                <CustomTableHead key={field.fieldName} className={cn(field.fieldName == "delete" ? "w-[80px]" : 'w-[200px]')}>
                                  {field.fieldName == "budgetYear" ? "Budget Month & Year" : field.displayLabel}
                                </CustomTableHead>
                              )
                            })}
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {lineItemRows.map((_, index) => (
                            <TableRow>
                              {lineItemFields.map((field: any) => {
                                if (isFieldSkipped(field.fieldName)) return <></>
                                return (
                                  <CustomTableCell key={field.fieldName} className="pb-7">
                                    {field?.fieldName == "delete" ? fieldDisabled ? <></> :
                                      <Trash2 className="stroke-red-600 h-5 w-5" onClick={() => removeRow(index)} /> :
                                      renderDynamicField(field, form, index)}
                                  </CustomTableCell>
                                )
                                })}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div> :
                    <NoData />
                }
              </CardContent>
            </Card>}

            <div className="flex flex-end justify-end gap-3">
              {!fieldDisabled && !isNextJeMasterIdExists && hasEditPermission ? <Button type="submit" disabled={balanceAmount != 0}><RotateCcw className="h-4 w-4" />Retry Submission</Button> : <></>}
              {prevStageId ? <Button type="button" disabled={!prevStageId} onClick={onPrev}><ArrowLeft className="h-4 w-4" />Previous</Button> : <></>}
              {nextStageId ? <Button type="button" disabled={!nextStageId} onClick={onNext}><ArrowRight className="h-4 w-4" />Next</Button> : <></>}
            </div>
          </div>
        </form>
      </FormProvider>
    }
  </div>
}

export default ManualEntry;